<div class="space-y-3">
  @for (participant of participants(); track participant.participantId) {
    <article
      class="overflow-hidden rounded-[2rem] border border-black/[0.05] bg-white shadow-sm transition-all"
    >
      <button
        type="button"
        (click)="toggleParticipant(participant.participantId)"
        class="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition active:bg-black/[0.02]"
      >
        <div class="flex min-w-0 items-center gap-3">
          <div
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white font-bold text-[#eb6608] shadow-sm text-sm border border-orange-100"
          >
            {{ getInitial(participant.participantName) }}
          </div>
          <p class="truncate text-base font-bold text-[#1f1b16] uppercase tracking-tight">
            {{ participant.participantName }}
          </p>
        </div>

        <div class="flex shrink-0 items-center gap-2">
          <p class="text-lg font-black text-[#eb6608] tracking-tighter">
            {{ participant.totalToPay | moneyDisplay: currency() }}
          </p>
          <svg
            class="h-5 w-5 text-[#3a332c]/30 transition-transform duration-300"
            [class.rotate-180]="isExpanded(participant.participantId)"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
          >
            <path d="M19 9l-7 7-7-7" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </button>

      @if (isExpanded(participant.participantId)) {
        <div
          class="border-t border-black/[0.03] bg-[#fcfaf7]/50 px-5 py-5 animate-in slide-in-from-top-2 duration-200"
        >
          <div class="space-y-4">
            <p class="text-[10px] font-bold uppercase tracking-widest text-[#3a332c]/40 mb-2">
              Consumos detallados
            </p>

            @for (item of participant.items; track item.itemId) {
              <div class="flex items-center justify-between gap-4">
                <div class="flex flex-col min-w-0 flex-1">
                  <div class="flex items-baseline gap-2">
                    <span
                      class="text-sm font-bold text-[#1f1b16] uppercase tracking-tight truncate"
                    >
                      {{ item.description }}
                    </span>
                    @if (getItemConcept(item)) {
                      <span
                        class="shrink-0 text-[10px] font-bold text-[#eb6608]/70 italic whitespace-nowrap"
                      >
                        ({{ getItemConcept(item) }})
                      </span>
                    }
                  </div>
                </div>

                <span class="shrink-0 text-sm font-black text-[#1f1b16] tabular-nums">
                  {{ item.amount | moneyDisplay: currency() }}
                </span>
              </div>
            }
          </div>

          <div class="mt-6 space-y-2 border-t border-black/[0.05] pt-4">
            <div class="flex items-center justify-between text-[#3a332c]/60">
              <span class="text-xs font-medium">Subtotal consumos</span>
              <span class="text-xs font-bold tabular-nums">
                {{ participant.itemsTotal | moneyDisplay: currency() }}
              </span>
            </div>

            <div class="flex items-center justify-between text-[#3a332c]/60">
              <span class="text-xs font-medium">Cuota de propina</span>
              <span class="text-xs font-bold text-green-600 tabular-nums">
                + {{ participant.tipShare | moneyDisplay: currency() }}
              </span>
            </div>

            @if (participant.discountShare > 0) {
              <div class="flex items-center justify-between text-[#3a332c]/60">
                <span class="text-xs font-medium">Descuentos aplicados</span>
                <span class="text-xs font-bold text-emerald-600 tabular-nums">
                  - {{ participant.discountShare | moneyDisplay: currency() }}
                </span>
              </div>
            }

            <div class="flex items-center justify-between border-t border-black/5 mt-2 pt-3">
              <span class="text-sm font-black text-[#1f1b16] uppercase">Total final</span>
              <span class="text-xl font-black text-[#1f1b16] tracking-tighter tabular-nums">
                {{ participant.totalToPay | moneyDisplay: currency() }}
              </span>
            </div>
          </div>
        </div>
      }
    </article>
  }
</div>
